// --------------------Quick Fixes----------------------//

function modifyBtnNavToggle() {
  const navToggle = $('.mobile-nav-toggle');
  const bars = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="#fff" width="40" height="36"><!--!Font Awesome Free 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"/></svg>`;
  navToggle.html(bars);
  navToggle.attr('tabindex', '0');
  navToggle.attr('role', 'button');
  navToggle.attr('aria-label', 'open menu');
}

function modifySearchBox() {
  const searchInput = $('header .inputFieldTextbox');
  const searchButton = $('.header .searchSubmitButton');
  searchInput.attr('placeholder', 'Type here...');
  searchButton.attr('tabindex', '-1');
  searchButton.attr('aria-label', 'submit search');
}

function removeFocusCart() {
  const cartLink = $('.header .cartMenuLink');
  const href = (cartLink.attr('href') || '').trim();

  const isNavigable = href.startsWith('http');

  if (!isNavigable) {
    cartLink.attr('tabindex', '-1');
  }
}

// Header height observer
function observeHeaderHeight(selector = 'header', { offset = 0 } = {}) {
  const header = document.querySelector(selector);

  let scheduled = false;
  let lastHeight = null;

  function measure() {
    const rect = header.getBoundingClientRect();
    const style = getComputedStyle(header);
    const marginBottom = Number.parseFloat(style.marginBottom) || 0;
    return Math.round(rect.height + marginBottom + offset);
  }

  function apply() {
    scheduled = false;
    const h = measure();
    if (h === lastHeight) return;
    lastHeight = h;
    document.documentElement.style.setProperty('--header-height', `${h}px`);
  }

  function schedule() {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(apply);
    }
  }

  const ro = new ResizeObserver(schedule);
  ro.observe(header);

  // Primera medición
  schedule();

  return {
    destroy() {
      ro.disconnect();
    },
  };
}

// -------------------- Signup ----------------------//
function modifySignup() {
  const signupWidget = $('.emailSignup');
  const title = `<h3>Get Updates</h3>`;
  const label =
    'Join our email list and stay up to date with the latest news, info, and fair deals from the YMBL.';
  const signupText = signupWidget.find('.emailSignupText');
  const input = signupWidget.find('.inputFieldTextbox');
  const submit = signupWidget.find('.emailSubmitButton');
  // wrap all the signupWidget content in a div with class "inner-container"
  signupWidget.wrapInner('<div class="emailSignupTextContainer"></div>');

  signupText.text(label);
  $('.emailSignup.modalOnly').prepend(title);

  input.val('');
  input.attr('placeholder', 'Email Address');
  submit.text('Sign up');
  submit.attr('aria-label', 'Sign up to our newsletter');
}
// --------------------Lineup modifier----------------------//

function lineupButtonsGrid(lineup) {
  const containerSize = lineup.width();
  const buttonContainer = lineup.find('.featureLineup-buttons.subContainer');
  const icons = buttonContainer.find('.featureLineup-social');
  const buttons = buttonContainer.find('.featureLineup-buynow');

  // if icons length + buttons length is greater than containerSize then add class "grid" to buttonContainer

  if (icons.width() + buttons.width() > containerSize) {
    buttonContainer.addClass('column');
  }

  // remove icons if there 0 children
  if (!icons.children().length) {
    icons.remove();
  }
}

function modifyFeatureLineup() {
  $('.featureLineupContainer').each((i, element) => {
    const $element = $(element);

    lineupButtonsGrid($element);
  });
}

// --------------------COUNTDOWN----------------------//

// when body has class siteInfoBannerOn and doesn't have class siteInfoBannerWidgetDateIsPast catch the #siteInfoBannerWidget .countdownDays value and prepend inside the word 'Only'.

function modifyCountdown() {
  if (
    $('body').hasClass('siteInfoBannerOn') &&
    !$('body').hasClass('siteInfoBannerWidgetDateIsPast')
  ) {
    const countdownDays = $('#siteInfoBannerWidget .countdownDays');
    countdownDays.prepend('Only ');
  }
}

$(document).ready(() => {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  modifyBtnNavToggle();
  modifySearchBox();
  observeHeaderHeight('.header');
  // if is not homepage then modify featureLineup
  if (!$('body').hasClass('homepage')) {
    modifyFeatureLineup();
  }
  if (globalThis.location.pathname === '/') {
    modifySignup();
  }
});

$(globalThis).load(() => {
  // ---
  removeFocusCart();
  modifyCountdown();
});
